import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MessagingStatLog } from 'src/app/models/MessagingStatLog';
import { MessagingService } from 'src/app/services/messaging.service';

@Component({
  selector: 'app-email-error-dialog',
  templateUrl: './email-error-dialog.component.html',
  styleUrls: ['./email-error-dialog.component.less']
})
export class EmailErrorDialogComponent implements OnInit, OnDestroy {

  @Input() datas: MessagingStatLog;
  $error: Subscription;
  @Output() emailResolved: EventEmitter<MessagingStatLog> = new EventEmitter();
  constructor(public mess: MessagingService, public toast: ToastrService, public modalService: NgbModal) 
  {
  
  }
  ngOnDestroy(): void {
    if(this.$error) this.$error.unsubscribe();
  }
  ngOnInit(): void {
    console.log(this.datas);
  }

  resolveError() {
    this.$error = this.mess.resolveEmailError(this.datas).pipe(tap((_ : MessagingStatLog) => {
      if(_.errorResolved){
        this.toast.success('Error marked resolved!');
      }else{
        this.toast.error('Error resolving email log', '', { closeButton: true, disableTimeOut: true });
      }
      // this.datas = _;
      this.emailResolved.emit(_);
    },
    e => {
      this.toast.error('Error resolving email log', '', { closeButton: true, disableTimeOut: true });
    },
    () => { this.modalService.dismissAll();})).subscribe();
  }
}
